<template>
  <Portal to="modals">
    <!-- <transition name="fade"> -->
    <div class="gp_modal gp_modal__common" :class="classs" @mousedown.self="handleCancel" @keyup.esc="handleCancel" ref="main" v-bind="scopeAttrs">
      <div class="gp_modal-backdrop" @mousedown.prevent="overlayClick" v-if="!noBackdrop"></div>
      <div class="gp_modal-container" :class="[cClass, padding]" @mousedown.left.self="$emit('container')">
        <template v-if="hasHeader">
          <header class="gp_modal-container_header" :class="hClass">
            <slot name="header"></slot>
            <div class="gp_modal-container_header__close" :class="closeClass" v-if="!hideExit" @click.prevent="handleCancel">
              <i class="icon icon-cancel" :class="iClass"></i>
            </div>
          </header>
        </template>
        <header class="gp_modal-container_actions" :class="aClass" v-if="hasActions">
          <slot name="actions"></slot>
        </header>
        <section class="gp_modal-container_body" :class="mClass" v-if="hasBody">
          <slot></slot>
        </section>
        <footer class="gp_modal-container_footer" :class="fClass" v-if="hasFooter">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
    <!-- </transition> -->
  </Portal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    aClass: String,
    cClass: String,
    hClass: {
      type: String,
      default: ""
    },
    iClass: {
      type: String,
      default: ""
    },
    closeClass: {
      type: String,
      default: ""
    },
    mClass: {
      type: String,
      default: ""
    },
    fClass: {
      type: String,
      default: ""
    },
    padding: {
      type: String
    },
    noBackdrop: {
      type: Boolean,
      default: false
    },
    hideExit: {
      type: Boolean,
      default: true
    },
    breakLine: {
      type: Boolean,
      default: false
    },
    preventBackdrop: {
      type: Boolean,
      default: false
    },
    classs: String
  },
  computed: {
    hasHeader() {
      return !!this.$slots["header"] || !!this.$scopedSlots["header"];
    },
    hasActions() {
      return !!this.$slots["actions"] || !!this.$scopedSlots["actions"];
    },
    hasBody() {
      return !!this.$slots["default"] || !!this.$scopedSlots["default"];
    },
    hasFooter() {
      return !!this.$slots["footer"] || !!this.$scopedSlots["footer"];
    },
    scopeAttrs() {
      // Get the scope attribute name (undefined if none)
      const scopeAttr = this.$parent.$options._scopeId;
      return scopeAttr ? { [scopeAttr]: "" } : {};
    }
  },
  mounted() {
    const isInViewport = this.isInViewport();
    this.$store.commit("account/IS_MODAL_VIEWING", isInViewport);
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.$store.commit("account/IS_MODAL_VIEWING", false);
    },
    overlayClick() {
      if (this.preventBackdrop) {
        return;
      }
      this.$store.commit("account/IS_MODAL_VIEWING", false);
      this.handleCancel();
    },
    isInViewport() {
      const rect = this.$el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }
};
</script>

<style lang="scss">
$baseIndex: $modalIndex;
.gp_modal__common {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include flex-center;
  .gp_modal {
    &-backdrop {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 5;
      background: rgba(#000, 0.5);
    }
  
    &-container {
      position: relative;
      background: map-get($hybrid-shade-light, "100");
      max-height: 80vh;
      display: flex;
      z-index: 10;
      flex-direction: column;
      border-radius: $radius;
  
      &_header {
        display: flex;
        position: relative;
        padding: 12px 16px;
        align-items: center;
        border-bottom: 1px solid map-get($hybrid-shade-light, "400");
        
        &__title {
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          color: map-get($text-light-mode, 'high-contrast');
          flex: 1;
        }
        &__close {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
          cursor: pointer;
          margin-left: 8px;
          .icon {
            font-size: 11px;
            color: map-get($text-light-mode, 'high-contrast');
          }
          &:hover {
            background: rgba(0, 0, 0, 0.1);
          }
        }
      }
      &_body {
        padding: 16px;
        max-height: 80vh;
        overflow-y: auto;
        @-moz-document url-prefix() {
          overflow-y: auto;
        }
      }
      &_footer {
        border-top: 1px solid map-get($hybrid-shade-light, "400");
        padding: 12px 16px;
        .gf_btn__action {
          padding: 8.5px 23px;
          border: 1px solid map-get($hybrid-shade-dark, "100");
          &-group {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          &.btn-outline {
            background: map-get($hybrid-shade-light, "100");
            &:hover {
              background: #E5E5E5;
              border: 1px solid map-get($hybrid-shade-dark, "100");
            }
          }
          &.btn-primary {
            background: map-get($primary-blue, "300");
            border: 1px solid map-get($primary-blue, "300");
            &:hover {
              background: #365DE5;
              border: 1px solid #365DE5;
            }
          }
          &.btn-danger {
            background: map-get($accent-red-new, "300");
            border: 1px solid map-get($accent-red-new, "300");
            &:hover {
              background: #DC3C31;
              border: 1px solid #DC3C31;
            }
          }
          
        }
      }
      &_actions {
        position: relative;
      }
  
      
    }
  
    &-close {
      z-index: 1;
      position: absolute;
      top: 15px;
      right: 15px;
      display: flex;
      @include flex-center;
      // padding: 15px;
      // @include trans-all;
      color: $textLightModeLow;
      margin-left: auto;
  
      font-size: 18px;
      cursor: pointer;
      border-radius: $radius;
      // background: $light3;
      &:hover {
        color: $textLightModeHigh;
        background: $textDarkModeHigh;
      }
    }

    .line {
      background-color: $bg;
      height: 1px;
    }
  }
  &.gf_modal-sm {
    .gp_modal-container {
      width: 600px;
      max-width: 600px;
    }
  }
}

.preview-template {
  padding: 0 !important;
  width: 100%;
  height: 100vh;
  border-radius: inherit;
  .index-0 {
    z-index: 0;
  }
  .gp_modal-container {
    &_body {
      max-height: unset;
      overflow: unset;
    }
  }
}

.height-unlimit {
  max-height: unset;
  overflow: unset;
}

.btn-select-template {
  padding: 15px 20px;
}

.w93p {
  width: 93%;
  position: relative;
}

.bg-white {
  background: white;
}

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
.app-details-close {
  top: 24px;
  right: 24px;
}

.w-200 {
  width: 600px;
}
.header-footer-not-avaible-body {
  padding: 20px 20px 16px 20px;
}
.header-footer-not-avaible-header {
  padding: 17px 20px;
}
</style>
